type MembershipFinanceFields = {
  org_id?: string | null;
  role?: string | null;
  can_view_financials?: boolean | null;
  can_view_billing?: boolean | null;
  permissions?: unknown;
};

function permissionFlag(raw: unknown, key: string): boolean {
  if (raw == null || typeof raw !== "object") return false;
  return (raw as Record<string, unknown>)[key] === true;
}

export function membershipCanViewOrgFinancials(args: {
  role: string | null | undefined;
  canViewFinancials?: boolean | null;
  canViewBilling?: boolean | null;
  permissions?: unknown;
  globalCoordinatorViewFinancials?: boolean | null;
}): boolean {
  const r = (args.role ?? "").trim().toLowerCase();
  if (
    r === "owner" ||
    r === "wlasciciel" ||
    r === "właściciel" ||
    r === "admin" ||
    r === "administrator"
  ) {
    return true;
  }
  if (r === "coordinator" || r === "koordynator") {
    return (
      args.canViewFinancials === true ||
      args.canViewBilling === true ||
      args.globalCoordinatorViewFinancials === true ||
      permissionFlag(args.permissions, "can_view_financials")
    );
  }
  return false;
}

export function pickCurrentMembership<T extends MembershipFinanceFields>(
  memberships: T[],
  currentOrgId: string | null | undefined,
  currentRole: string | null | undefined
): T | undefined {
  return (
    memberships.find(
      (m) => m.org_id === currentOrgId && m.role === currentRole
    ) ?? memberships.find((m) => m.org_id === currentOrgId)
  );
}
